export default __webpack_public_path__ + "static/media/step-unvisited.77f29fb1.svg";